var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const defaultIdPrefix = 'bgImg_';
const BackgroundImage = props => {
    var _a, _b, _c;
    const { className, customIdPrefix, getPlaceholder } = props, backgroundImage = __rest(props, ["className", "customIdPrefix", "getPlaceholder"]);
    const tileImagedInfoString = React.useMemo(() => JSON.stringify({
        containerId: backgroundImage.containerId,
        alignType: backgroundImage.alignType,
        fittingType: backgroundImage.displayMode,
        imageData: Object.assign(Object.assign({ width: backgroundImage.width, height: backgroundImage.height, uri: backgroundImage.uri, name: backgroundImage.name }, (backgroundImage.quality && { quality: backgroundImage.quality })), { displayMode: backgroundImage.displayMode }),
    }), [backgroundImage]);
    const imagePlaceholderData = React.useRef(null);
    if (!imagePlaceholderData.current) {
        imagePlaceholderData.current = getPlaceholder
            ? getPlaceholder({
                fittingType: backgroundImage.displayMode,
                src: {
                    id: backgroundImage.uri,
                    width: backgroundImage.width,
                    height: backgroundImage.height,
                    name: backgroundImage.name,
                },
                target: {
                    width: backgroundImage.containerWidth,
                    height: backgroundImage.containerHeight,
                    alignment: backgroundImage.alignType,
                    htmlTag: 'bg',
                },
            })
            : // to keep an empty placeholder data
                {
                    uri: undefined,
                    css: { img: {} },
                    attr: { img: {}, container: {} },
                };
    }
    const currentPlaceholder = imagePlaceholderData.current;
    const src = (_a = currentPlaceholder === null || currentPlaceholder === void 0 ? void 0 : currentPlaceholder.uri) !== null && _a !== void 0 ? _a : '';
    const placeholderStyle = (_c = (_b = currentPlaceholder.css) === null || _b === void 0 ? void 0 : _b.container) !== null && _c !== void 0 ? _c : {};
    const placeholder = Object.assign(src
        ? {
            backgroundImage: `url(${src})`,
        }
        : {}, placeholderStyle);
    return (
    // 	Custom element defined in: https://github.com/wix-private/santa-core/blob/master/wix-custom-elements/src/elements/wixBgImage/wixBgImage.js
    React.createElement("wix-bg-image", { id: `${customIdPrefix || defaultIdPrefix}${backgroundImage.containerId}`, class: className, style: placeholder, "data-tiled-image-info": tileImagedInfoString, "data-has-bg-scroll-effect": backgroundImage.hasBgScrollEffect || '', "data-bg-effect-name": backgroundImage.bgEffectName || '' }));
};
export default BackgroundImage;
//# sourceMappingURL=BackgroundImage.js.map